<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import { version } from '../package'

  export default {
    name: 'app',
    mounted () {
      document.title = 'webcg-studio ' + version
    },
    watch: {
      $keycloak: {
        handler: function (val) {
          window.clearInterval(this.updateKeycloakTokenId)
          if (val.ready && !val.authenticated) {
            const url = this.$env.MANAGER_URL
            if (url) {
              console.log('[app] redirecting to ' + url)
              window.location = url
            } else {
              console.error('[app] no authentication endpoint configured. Specify MANAGER_URL and/or KEYCLOAK_URL.')
            }
          }
          if (val.ready && val.authenticated) {
            this.updateKeycloakTokenId = window.setInterval(() => {
              console.debug('[app] updating keycloak token')
              val.updateToken().then(() => {
                console.debug('[app] keycloak token updated')
              }).catch(() => {
                window.clearInterval(this.updateKeycloakTokenId)
                console.debug('[app] failed to update keycloak token')
              })
            }, 3 * 60 * 1000)
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss">
  @import './scss/variables';
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import '~bootstrap/scss/bootstrap';
  @import './scss/webcg';
</style>



// WEBPACK FOOTER //
// src/App.vue